import { QueryKeys } from '@frontend/features/common/types';

export interface BookingErrorRecoveryQueryClient {
  invalidateQueries: (filters: { queryKey: unknown[] }) => unknown;
}

export async function refreshBookingAfterOperationError<TBooking>({
  bookingId,
  fetchBooking,
  onBooking,
  queryClient,
}: {
  bookingId: string;
  fetchBooking: (bookingId: string) => Promise<TBooking>;
  onBooking: (booking: TBooking) => void;
  queryClient: BookingErrorRecoveryQueryClient;
}): Promise<TBooking | null> {
  try {
    const booking = await fetchBooking(bookingId);
    onBooking(booking);
    return booking;
  } catch {
    return null;
  } finally {
    queryClient.invalidateQueries({ queryKey: [QueryKeys.getTravelBookings] });
  }
}
